import * as React from 'react';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Footer from './views/footer';
import { useLocation } from 'react-router-dom';
import LoadingPage from './views/LoadingPage';

interface PublicRouteProps {
  children: React.ReactElement<any, any>;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const [isNavigationLoading] = React.useState(false);

  return isNavigationLoading ? (
    <Box
      sx={{
        height: '100dvh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <LoadingPage />
    </Box>
  ) : (
    // children
    <Box>
      <Box style={{minHeight: '100dvh'}}>
        {children}
      </Box>
      <Footer />
    </Box>
  );
};

export default PublicRoute;
